import { useTranslation } from 'react-i18next';

import CopyButton from '@/components/atoms/CopyButton/CopyButton';
import PlainFieldset from '@/components/atoms/Fieldset/templates/PlainFieldset';
import { Input } from '@/components/ui/input';
import { Desk } from '@/shared/types/desk';

interface Props {
  desk?: Desk;
}

const DeskIdFieldset = ({ desk }: Props) => {
  const { t } = useTranslation();
  return (
    <PlainFieldset className="mb-8" title={t('desks.environment_id')} isLoading={!desk?.desk_id}>
      <div className="flex items-center">
        <Input defaultValue={desk?.desk_id} readOnly />
        <CopyButton className="ml-2" data={desk?.desk_id} />
      </div>
    </PlainFieldset>
  );
};

export default DeskIdFieldset;
